import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      const values = event.exception?.values ?? [];
      for (const v of values) {
        const msg = v.value ?? "";
        // Filter out AbortError from Supabase auth-js navigator lock timeout.
        // This is a benign internal error in @supabase/gotrue-js when the
        // browser lock acquisition times out — not actionable.
        if (msg.includes("signal is aborted without reason")) {
          return null;
        }
        // Filter out transient network errors (not actionable).
        if (v.type === 'TypeError' && msg === 'Failed to fetch') {
          return null;
        }
        // Filter out browser extension errors (not our code).
        if (
          msg.includes("runtime.sendMessage()") ||
          msg.includes("Object Not Found Matching Id")
        ) {
          return null;
        }
      }
      return event;
    },
  });
}
